module.exports = __webpack_public_path__ + "static/media/icon-user-blue.f8739f45.svg";